/**
 * Object Fit Polyfills
 * @link https://github.com/bfred-it/object-fit-images
 * @link https://github.com/TricomB2B/object-fit-videos

 * @todo maybe replace above with https://github.com/constancecchen/object-fit-polyfill
 * once https://github.com/constancecchen/object-fit-polyfill/issues/53 is resolved
 */

import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';

function init() {
  objectFitImages();
  objectFitVideos();
}

export default init;



// WEBPACK FOOTER //
// ./scripts/base/objectFit.js